
import { useEffect, useState } from "react";
import { Menu, X, ShieldCheck } from "lucide-react";
import logo from "/src/assets/Logo.png";
const NAV = [
  { id: "home", label: "Home" },
  { id: "about", label: "About Us" },
  { id: "certifications", label: "Certifications" },
  { id: "services", label: "Services" },
  { id: "projects", label: "Projects" },
  { id: "training", label: "Training" },
  { id: "contact", label: "Contact Us" },
];

export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);

    onScroll();

    window.addEventListener("scroll", onScroll, {
      passive: true,
    });

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  useEffect(() => {
    const sections = document.querySelectorAll("section[id]");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      {
        threshold: 0.5,
      }
    );

    sections.forEach((section) => {
      observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  const scrollTo = (id: string) => {
    setOpen(false);

    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled
          ? "bg-navy-deep/95 backdrop-blur-md shadow-lg"
          : "bg-gradient-to-b from-navy-deep/70 to-transparent"
        }`}
    >
      <div className="container-x flex h-32 items-center justify-between gap-4">
        <button
          onClick={() => scrollTo("home")}
          className="flex min-w-0 items-center gap-3 text-left  cursor-pointer"
          aria-label="Solid Proof home"
        >

          <img src={logo}  className="h-32 w-auto sm:h-16 md:h-32 lg:h-32 " />


       
            <span className="text-lg font-black tracking-tight text-white">
              SOLID PROOF ENERGY
            </span>

          {/*   <span className="text-[10px] font-medium uppercase tracking-[0.2em] text-white/60">
              Inspection • Certification
            </span> */}
         
        </button>

        <nav className="hidden items-center gap-1 lg:flex">
          {NAV.map((n) => (
            <button
              key={n.id}
              onClick={() => scrollTo(n.id)}
              className={`cursor-pointer
                relative rounded-md px-3 py-2 text-sm font-medium transition-colors
                ${activeSection === n.id
                  ? "text-white"
                  : "text-white/85 hover:bg-white/10 hover:text-white"
                }`}
            >
              {n.label}

              {activeSection === n.id && (
                <span className="absolute bottom-0 left-1/2 h-[2px] w-8 -translate-x-1/2 rounded-full bg-white" />
              )}
            </button>
          ))}
        </nav>

        <div className="hidden lg:block">
          <button
            onClick={() => scrollTo("contact")}
            className="rounded-md bg-orange px-5 py-2.5 text-sm font-semibold text-white shadow-lg transition-all hover:bg-orange-hover hover:shadow-xl"
          >
            Request Service
          </button>
        </div>

        <button
          className="grid h-11 w-11 place-items-center rounded-md text-white lg:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? (
            <X className="h-6 w-6" />
          ) : (
            <Menu className="h-6 w-6" />
          )}
        </button>
      </div>

      {open && (
        <div className="border-t border-white/10 bg-navy-deep lg:hidden">
          <div className="container-x flex flex-col gap-1 py-4">
            {NAV.map((n) => (
              <button
                key={n.id}
                onClick={() => scrollTo(n.id)}
                className={`rounded-md px-3 py-3 text-left text-base font-medium transition-colors
                  ${activeSection === n.id
                    ? "bg-white/10 text-white"
                    : "text-white/90 hover:bg-white/10"
                  }`}
              >
                {n.label}
              </button>
            ))}

            <button
              onClick={() => scrollTo("contact")}
              className="mt-2 rounded-md bg-orange px-5 py-3 text-center text-sm font-semibold text-white"
            >
              Request Inspection
            </button>
          </div>
        </div>
      )}
    </header>
  );
}